import { render } from "./ClientRequestsTable.vue?vue&type=template&id=0b0d9c4f"
import script from "./ClientRequestsTable.vue?vue&type=script&lang=js"
export * from "./ClientRequestsTable.vue?vue&type=script&lang=js"

import "./ClientRequestsTable.vue?vue&type=style&index=0&id=0b0d9c4f&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__